/**
 * Denis Callinan
 * Project Andromeda
 * August 2nd, 2020
 * Experience.js - Section for experience
 */

import React from 'react';

// Components
import SectionHeader from '../components/SectionHeader/SectionHeader.js';
import ExpBox from '../components/ExpGrid/ExpBox.js';

// Info
import exp from '../info/exp.json';

export default class Experience extends React.Component {
    render() {
        var boxes = exp.map(element => {
            return <ExpBox
                width = {this.props.state.windowWidth} 
                title = {element["title"]}
                time = {element["dur"]}
                desc = {element["desc"]}
                photos = {element["photo"]}
            />
        });
        return(
            <div className = "page" id = "page-C">
                <SectionHeader sectionID = "experience-break" title = "EXPERIENCE" />
                {boxes}
            </div>
        );
    }
}